//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from 'config/index';
import HandleApiResponse from 'helpers/handleApiResponse';

const language = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function selectedLanguage(input) {
    try {
      const obj = {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify(input)
      };

      let res = await fetch(
        `${config.host}/cdr-panel/language/selected-language`,
        obj
      );

      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  return { selectedLanguage };
};

export default language;
